(() => {
  const slugify = (str) =>
    (str || '')
      .toString()
      .trim()
      .toLowerCase()
      .replace(/<\/?[^>]+(>|$)/g, '')
      .replace(/[^\w\s-]/g, '')
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-');

  const initSeoBlock = (seo) => {
    const text = seo.querySelector('.seo-text');
    if (!text) return;



    // Default kısa görünüm + Lire plus
    seo.classList.add('is-collapsed');

    const btn = document.createElement('button');
    btn.className = 'seo-more';
    btn.type = 'button';
    btn.setAttribute('aria-expanded', 'false');
    btn.textContent = 'Lire plus';

    btn.addEventListener('click', () => {
      const collapsed = seo.classList.toggle('is-collapsed');
      btn.setAttribute('aria-expanded', String(!collapsed));
      btn.textContent = collapsed ? 'Lire plus' : 'Lire moins';
    });

    // Butonu en alta ekle
    seo.appendChild(btn);
  };

  const run = () => {
    document.querySelectorAll('.seo').forEach(initSeoBlock);
  };

  window.addEventListener('load', run);
  document.addEventListener('shopify:section:load', run);
})();